import {
  NotificationsMsSearchNotificationsRequestFilters,
  NotificationsMsSearchNotificationsRequestSort,
  NotificationsMsSearchNotificationsResponseDataFailedReason,
  NotificationsMsSearchNotificationsResponseDataStatus,
} from "@/api/graphql/types/graphql.ts";

export interface GetNotificationsRequest {
  filters?: NotificationsMsSearchNotificationsRequestFilters;
  paging?: {
    page: number;
    size: number;
  };
  sorts?: NotificationsMsSearchNotificationsRequestSort;
}

export interface NotificationBO {
  id: string;
  subject: string;
  hasAttachments: boolean;
  createdTs: number;
  accountNumber?: string;
  accountName?: string;
  roleProfileCode?: string;
  roleProfileName?: string;
  status: NotificationsMsSearchNotificationsResponseDataStatus;
  failedReason: NotificationsMsSearchNotificationsResponseDataFailedReason;
}

export interface NotificationsPaginationBO {
  page: number;
  size: number;
  total: number;
}

export interface NotificationsPageBO {
  data: NotificationBO[];
  pagination: NotificationsPaginationBO;
}

export const createEmptyNotificationsPage = (
  page = 1,
  size = 0,
): NotificationsPageBO => ({
  data: [],
  pagination: {
    page,
    size,
    total: 0,
  },
});

export interface GetNotificationsByUser {
  pageSize: number;
  userId: string;
}

export interface GetNotificationsByAccount {
  pageSize: number;
  accountId: string;
}

export interface CompanyNameProps {
  code: string | undefined;
  name: string | undefined;
  tNotifications: (key: string) => string;
}
